import { t } from 'app/shared/i18n';
import { MessageResolverMap } from './types';
import { mapFileFormatsForErrorMap } from './utils';

export const errorMap: MessageResolverMap<'error'> = {
  REQUIRED: wording => wording.message.validate_message.required,
  REPEATED: wording => wording.message.error.repeated,
  INVALID_ATTR_EMAIL: wording => wording.message.validate_message.email,
  INVALID_ATTR_TEL: wording => wording.message.validate_message.digits,
  INVALID_ATTR_URL: wording => wording.message.validate_message.url,
  INVALID_NUMBER: wording => wording.message.validate_message.number,
  INVALID_RANGE: (wording, message) => {
    const { gte, lte } = message.payload!;

    if (gte || gte === 0) {
      return t(wording.message.validate_message.min, { 0: gte });
    } else if (lte || lte === 0) {
      return t(wording.message.validate_message.max, { 0: lte });
    }
  },
  INVALID_DECIMAL: wording => wording.message.error.invalid_decimal,
  INVALID_FILEUPLOAD_DISABLE: wording =>
    wording.subject.fileupload.status.disabled,
  INVALID_FILEUPLOAD_FAILED: wording =>
    wording.subject.fileupload.status.failed,
  INVALID_FILEUPLOAD_PREVIEW: wording =>
    wording.subject.fileupload.status.preview,
  INVALID_FILEUPLOAD_SPACE_NOT_ENOUGH: wording =>
    wording.subject.fileupload.status.fulled,
  INVALID_FILE: (wording, message) => {
    const { lte, format } = message.payload!;

    if (format instanceof Array) {
      return mapFileFormatsForErrorMap(wording, format);
    } else if (typeof lte === 'number') {
      return t(wording.subject.fileupload.error.filesize, { filesize: lte });
    }

    return;
  },
  INVALID_SORT: wording => wording.message.error.invalid_sort,
  INVALID_OPTION_COUNT: (wording, message) => {
    if (message.payload) {
      const { decrease, increase } = message.payload;

      if (increase) {
        return t(wording.message.error.invalid_option_count.too_little, {
          gap: increase
        });
      }

      if (decrease) {
        return t(wording.message.error.invalid_option_count.too_much, {
          gap: decrease
        });
      }
    }

    return;
  },
  INVALID_TEXT_LENGTH: (wording, message) => {
    if (!message.payload) {
      return;
    }

    const { gte, lte } = message.payload!;
    return t(wording.message.error.text_length, { 0: gte!, 1: lte! });
  }
};
